<template>
  <div class="ev-modal">
    <!-- Header -->
    <div class="ev-modal-header window-header">
      <span class="ev-modal-icon">👤</span>
      <h2 class="ev-modal-title">{{ title }}</h2>
    </div>

    <!-- Body -->
    <div class="ev-modal-body">
      <!-- Row 1: Ime & Prezime -->
      <div class="ev-form-row">
        <div class="ev-form-group">
          <label class="ev-form-label">Ime</label>
          <input
            class="ev-input"
            type="text"
            v-model="selectedEmployee.firstName"
            placeholder="Unesite ime"
          />
        </div>
        <div class="ev-form-group">
          <label class="ev-form-label">Prezime</label>
          <input
            class="ev-input"
            type="text"
            v-model="selectedEmployee.lastName"
            placeholder="Unesite prezime"
          />
        </div>
      </div>

      <!-- Row 2: Sektor & Nadređeni -->
      <div class="ev-form-row">
        <div class="ev-form-group">
          <label class="ev-form-label">Sektor</label>
          <vue-select
            class="ev-select"
            label="name"
            :clearable="false"
            :options="departments"
            v-model="selectedEmployee.department"
          />
        </div>
        <div class="ev-form-group">
          <label class="ev-form-label">Nadređeni</label>
          <vue-select
            class="ev-select"
            label="name"
            :clearable="true"
            :options="activeEmployees"
            v-model="superiorEmployee"
            placeholder="Izaberite..."
          />
        </div>
      </div>

      <!-- Row 3: Datumi -->
      <div class="ev-form-row">
        <div class="ev-form-group">
          <label class="ev-form-label">Datum početka</label>
          <date-picker
            v-model="selectedEmployee.startDate"
            class="ev-date-picker"
            placeholder="Izaberite datum"
          />
        </div>
        <div class="ev-form-group">
          <label class="ev-form-label">Datum kraja</label>
          <date-picker
            v-model="selectedEmployee.endDate"
            class="ev-date-picker"
            placeholder="Izaberite datum"
          />
        </div>
      </div>

      <!-- Row 4: Status, Indeks, Radno vrijeme -->
      <div class="ev-form-row ev-form-row--three">
        <div class="ev-form-group ev-form-group--checkbox">
          <label class="ev-checkbox-label">
            <input type="checkbox" v-model="selectedEmployee.status" />
            <span class="ev-checkbox-text">Aktivan</span>
          </label>
        </div>
        <div class="ev-form-group">
          <label class="ev-form-label">Indeks poretka</label>
          <input
            class="ev-input ev-input--sm"
            type="text"
            v-model="selectedEmployee.remoteId"
          />
        </div>
        <div class="ev-form-group ev-form-group--checkbox">
          <label class="ev-checkbox-label">
            <input type="checkbox" v-model="isShiftSpecial" />
            <span class="ev-checkbox-text">Posebno radno vrijeme</span>
          </label>
        </div>
      </div>

      <!-- Posebno radno vrijeme dropdown -->
      <div v-if="isShiftSpecial" class="ev-form-row">
        <div class="ev-form-group ev-form-group--full">
          <label class="ev-form-label">Radno vrijeme</label>
          <vue-select
            class="ev-select"
            label="name"
            :clearable="false"
            :options="shifts"
            @option:selected="shiftSelected"
            v-model="selectedShift"
          />
        </div>
      </div>

      <!-- Promjena sektora -->
      <div class="ev-section-divider">
        <label class="ev-checkbox-label">
          <input type="checkbox" v-model="isDepartmentChanging" />
          <span class="ev-checkbox-text">Promjena sektora</span>
        </label>
      </div>

      <div v-if="isDepartmentChanging" class="ev-form-row">
        <div class="ev-form-group">
          <label class="ev-form-label">Novi sektor</label>
          <vue-select
            class="ev-select"
            label="name"
            :clearable="false"
            :options="departments"
            v-model="newDepartment"
          />
        </div>
        <div class="ev-form-group">
          <label class="ev-form-label">Datum promjene</label>
          <date-picker
            class="ev-date-picker"
            v-model="departmentChangeDate"
            type="date"
            format="DD.MM.YYYY"
            placeholder="Izaberite datum"
          />
        </div>
      </div>

      <!-- Generiši korisnika -->
      <div class="ev-section-divider">
        <label class="ev-checkbox-label">
          <input type="checkbox" v-model="generateUser" />
          <span class="ev-checkbox-text"
            >Omogući pristup aplikaciji (SMS obavještenje)</span
          >
        </label>
      </div>
    </div>

    <!-- Footer -->
    <div class="ev-modal-footer">
      <button
        v-if="isSaveAndProceedButtonVisible"
        :disabled="!canProceed(selectedEmployee)"
        class="ev-btn ev-btn-secondary"
        @click="saveAndProceedButtonClicked"
      >
        Sačuvaj i nastavi
      </button>
      <button
        :disabled="!canProceed(selectedEmployee)"
        class="ev-btn ev-btn-primary"
        @click="saveAndCloseButtonClicked"
      >
        Sačuvaj i zatvori
      </button>
    </div>
  </div>
</template>

<script>
// import { getActiveEmployeesFromDepartmentData } from "../../_helpers/arrangers";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

const { DateTime } = require("luxon");

export default {
  name: "EditEmployee",

  props: {
    button1Name: String,
    button2Name: String,
    title: String,
    selectedEmployee: Object,
    departments: Array,
    shifts: Array,
    isSaveAndProceedButtonVisible: Boolean,
    AddOrEdit: Boolean,
  },

  components: {
    DatePicker,
  },

  data() {
    return {
      selectedShift: null,
      isShiftSpecial: false,
      activeEmployees: [],
      superiorEmployee: null,
      generateUser: false,
      isDepartmentChanging: false,
      newDepartment: null,
      departmentChangeDate: null,
    };
  },

  mounted() {
    // if employee has shiftOverrideId the shift is special
    this.isShiftSpecial =
      this.selectedEmployee.shiftOverrideId != null ? true : false;

    console.log(this.isShiftSpecial);

    console.log("selected employee:");
    console.log(this.selectedEmployee);

    // if shift is not special, selected shift is pulled from department
    if (!this.isShiftSpecial) {
      if (this.shifts.length !== 0) {
        this.selectedShift = this.shifts.filter((shi) => {
          return shi.id == this.selectedEmployee.department.shiftId;
        });
      }
    } else {
      if (this.shifts.length !== 0) {
        this.selectedShift = this.shifts.filter((shi) => {
          return shi.id == this.selectedEmployee.shiftOverrideId;
        });
      }
    }

    // console.log(this.selectedShift);
    console.log("selected EMPLOSEE");
    // console.log(new Date(this.selectedEmployee.startDate));
    this.selectedEmployee.startDate !== null
      ? (this.selectedEmployee.startDate = new Date(
          this.selectedEmployee.startDate
        ))
      : (this.selectedEmployee.startDate = null);
    this.selectedEmployee.endDate !== null
      ? (this.selectedEmployee.endDate = new Date(
          this.selectedEmployee.endDate
        ))
      : (this.selectedEmployee.endDate = null);

    this.superiorEmployee = this.$store.state.general.employees.find(
      (e) => e.id === this.selectedEmployee.reportsTo
    );
    this.activeEmployees = this.$store.state.general.employees;
  },

  methods: {
    shiftSelected() {
      // only if shift is special, put the override shift id
      if (this.isShiftSpecial) {
        this.selectedEmployee.shiftOverrideId = this.selectedShift.id;
      }
    },
    saveAndProceedButtonClicked() {
      this.arrangeResult();

      // If department change is requested, emit special event
      if (
        this.isDepartmentChanging &&
        this.newDepartment &&
        this.departmentChangeDate
      ) {
        this.$emit("departmentChangeRequested", {
          employeeId: this.selectedEmployee.employeeId,
          newDepartmentId: this.newDepartment.id,
          changeDate: DateTime.fromJSDate(this.departmentChangeDate)
            .toISO()
            .split("+")[0],
        });
      } else {
        this.$emit(
          "saveAndProceedClicked",
          this.selectedEmployee,
          this.generateUser
        );
      }
    },

    saveAndCloseButtonClicked() {
      this.arrangeResult();

      // If department change is requested, emit special event
      if (
        this.isDepartmentChanging &&
        this.newDepartment &&
        this.departmentChangeDate
      ) {
        this.$emit("departmentChangeRequested", {
          employeeId: this.selectedEmployee.employeeId,
          newDepartmentId: this.newDepartment.id,
          changeDate: DateTime.fromJSDate(this.departmentChangeDate)
            .toISO()
            .split("+")[0],
        });
      } else {
        this.$emit(
          "saveAndCloseClicked",
          this.selectedEmployee,
          this.generateUser
        );
      }
    },

    arrangeResult() {
      // reprotsTo
      this.selectedEmployee.reportsTo =
        this.superiorEmployee == null ? null : this.superiorEmployee.id;

      // startDate
      this.selectedEmployee.startDate !== null
        ? (this.selectedEmployee.startDate = DateTime.fromJSDate(
            this.selectedEmployee.startDate
          )
            .toISO()
            .split("+")[0])
        : null;

      // endDate
      this.selectedEmployee.endDate !== null
        ? (this.selectedEmployee.endDate = DateTime.fromJSDate(
            this.selectedEmployee.endDate
          )
            .toISO()
            .split("+")[0])
        : null;

      // department change data
      if (
        this.isDepartmentChanging &&
        this.newDepartment &&
        this.departmentChangeDate
      ) {
        this.selectedEmployee.departmentChange = {
          newDepartment: this.newDepartment,
          changeDate: DateTime.fromJSDate(this.departmentChangeDate)
            .toISO()
            .split("+")[0],
        };
      } else {
        this.selectedEmployee.departmentChange = null;
      }
    },
    canProceed(selectedEmployee) {
      if (selectedEmployee == null) {
        return false;
      }
      if (
        selectedEmployee.firstName == null ||
        selectedEmployee.lastName == null
      ) {
        return false;
      }
      if (
        selectedEmployee.firstName !== "" &&
        selectedEmployee.lastName !== ""
      ) {
        return true;
      }
      return false;
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
  },
};
</script>

<style scoped>
/* Modal Container */
.ev-modal {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  max-width: 650px;
}

/* Modal Header */
.ev-modal-header {
  background: var(
    --ev-primary-gradient,
    linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  );
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.ev-modal-icon {
  font-size: 22px;
}

.ev-modal-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Modal Body */
.ev-modal-body {
  padding: 16px 20px;
}

/* Form Row */
.ev-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}

.ev-form-row--three {
  grid-template-columns: auto 1fr auto;
  align-items: center;
}

/* Form Group */
.ev-form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ev-form-group--full {
  grid-column: 1 / -1;
}

.ev-form-group--checkbox {
  flex-direction: row;
  align-items: center;
}

/* Form Label */
.ev-form-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* Input */
.ev-input {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  background: #f8fafc;
  transition: all 0.2s ease;
}

.ev-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.ev-input--sm {
  padding: 6px 10px;
}

/* Checkbox */
.ev-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #475569;
}

.ev-checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #667eea;
  cursor: pointer;
}

.ev-checkbox-text {
  font-weight: 500;
}

/* Section Divider */
.ev-section-divider {
  padding: 10px 0;
  border-top: 1px solid #e2e8f0;
  margin-top: 8px;
}

/* Vue Select styling */
.ev-select :deep(.vs__dropdown-toggle) {
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  padding: 4px 8px;
  background: #f8fafc;
  min-height: 36px;
}

.ev-select :deep(.vs__dropdown-toggle:hover) {
  border-color: #667eea;
}

/* Date Picker */
.ev-date-picker :deep(.mx-input) {
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 12px;
  background: #f8fafc;
  font-size: 14px;
  height: 36px;
}

.ev-date-picker :deep(.mx-input:focus) {
  border-color: #667eea;
}

.ev-date-picker :deep(.mx-datepicker) {
  width: 100%;
}

/* Modal Footer */
.ev-modal-footer {
  padding: 12px 20px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Buttons */
.ev-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ev-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ev-btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.ev-btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.ev-btn-secondary {
  background: #e2e8f0;
  color: #475569;
}

.ev-btn-secondary:hover:not(:disabled) {
  background: #cbd5e1;
}
</style>